<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column spacing--padding-top">
    <mat-form-field
      class="flex__child--auto"
      *ngIf="propagationCompanies$ | async as propagationCompanies"
    >
      <mat-label>{{ 'order.propagation-company' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'order.propagation-company' | translate }}"
        formControlName="propagationCompany"
        data-test="order-item__propagation-company"
      >
        <mat-option
          *ngFor="let propagationCompany of propagationCompanies"
          [value]="propagationCompany"
          >{{ propagationCompany.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'order.expected-delivery-date' | translate }}</mat-label>
      <input
        formControlName="expectedDeliveryDate"
        matInput
        [matDatepicker]="expectedDeliveryDateDatePicker"
        placeholder="{{ 'order.expected-delivery-date' | translate }}"
        data-test="order-item__expected-delivery-date"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="expectedDeliveryDateDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker touchUi #expectedDeliveryDateDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'breed' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'breed' | translate }}"
        formControlName="breed"
        data-test="order-item__breed"
      >
        <mat-option *ngFor="let breed of breeds" [value]="breed">{{ breed.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'Female' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        formControlName="numberOfFemales"
        placeholder="{{ 'Female' | translate }}"
        data-test="order-item__number-of-females"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'Male' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        formControlName="numberOfMales"
        placeholder="{{ 'Male' | translate }}"
        data-test="order-item__number-of-males"
      />
    </mat-form-field>

    <mat-slide-toggle
      [hideIcon]="true"
      data-test="order-item__isFulFilled"
      color="primary"
      labelPosition="before"
      formControlName="isFulFilled"
    >
      {{ 'order.is-fulfilled' | translate }}
    </mat-slide-toggle>
  </div>
</agr-form-dialog>
